import React, { FC, ReactNode, createContext, useContext } from 'react';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export interface IOnboardingContext {
  onboardingEnabled: boolean;
}

export interface IOnboardingProps {
  children: ReactNode;
}

export const OnboardingContext = createContext<IOnboardingContext>({ onboardingEnabled: false });
export const useOnboardingContext = () => useContext<IOnboardingContext>(OnboardingContext);

export const OnboardingProvider: FC = ({ children }: IOnboardingProps) => {
  const onboardingEnabled = useFlag(LaunchDarklyFlag.ENABLE_FEATURE_ONBOARDING);

  return (
    <OnboardingContext.Provider value={{ onboardingEnabled }}>
      {children}
    </OnboardingContext.Provider>
  );
};
